import getYoutubeID from '../helpers/youtubeURL';

export default (settings, module_name) => {
  let cover = '';

  if (settings.overlay.image) {
    cover = `
      <div class="RteVideo__cover RteVideo__cover--active">
        <div class="RteVideo__cover-image" style="background-image:url('${settings.overlay.image}');"></div>
        <div class="PlayButton PlayButton--active" data-video-play-button></div>
      </div>
    `;
  }

  const html = `
    <div class="Module-${module_name}__Content">
      <div class="Module-${module_name}__Video">
        <div class="RteVideo" data-rte-video>
          ${cover}
        </div>
        <div class="Module-${module_name}__PlayButtonContainer">
          <div class="VideoPlayer__btn-play" 
            data-btn-play-modal-video 
            data-video-url="https://www.youtube.com/embed/${getYoutubeID(settings.video_url)}&autoplay=1">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play" class="svg-inline--fa fa-play fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#FFFFFF" d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path></svg>
          </div>
        </div>
      </div>
      <div class="Module-${module_name}__Caption">
        ${settings.caption}
      </div>
    </div>
  `;
  return html;
};

// ${cover}
